var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-manager-edit-gateway-configuration-preset-panel-control',{attrs:{"tree-node-id":_vm.gatewayId === undefined ? _vm.treeNodeId : _vm.gatewayId}})}
var staticRenderFns = []

export { render, staticRenderFns }